// badgeSystem.js - Cleaned version with mock functions and debug code removed

// Badge definitions
export const BADGE_DEFINITIONS = {
  "blogger": {
    id: "blogger",
    name: "Blogger",
    description: "Created your first blog post",
    baseColor: 'indigo',
    icon: () => (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18s-3.332.477-4.5 1.253" />
      </svg>
    ),
  },
  "first_post": {
    id: "first_post",
    name: "First Steps",
    description: "Created your first post",
    baseColor: 'cyan',
    icon: () => (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
      </svg>
    ),
  },
  "interpreter": {
    id: "interpreter",
    name: "Interpreter",
    description: "Made your first interpretation",
    baseColor: 'lime',
    icon: () => (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
      </svg>
    ),
  },
  "consistent": {
    id: "consistent",
    name: "Consistent Creator",
    description: "Active for 7 consecutive days",
    baseColor: 'teal',
    icon: () => (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
  },
  "streak_7": {
    id: "streak_7",
    name: "Week Warrior",
    description: "Maintained a 7-day streak",
    baseColor: 'red',
    icon: () => (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" />
      </svg>
    ),
  },
  "prolific_writer": {
    id: "prolific_writer",
    name: "Prolific Writer",
    description: "Created 10 blog posts",
    baseColor: 'fuchsia',
    icon: () => (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9.5a2 2 0 00-2-2h-2" />
      </svg>
    ),
  },
  "social_butterfly": {
    id: "social_butterfly",
    name: "Social Butterfly",
    description: "Made 50 comments",
    baseColor: 'pink',
    icon: () => (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
      </svg>
    ),
  },
  "streak_30": {
    id: "streak_30",
    name: "Monthly Master",
    description: "Maintained a 30-day streak",
    baseColor: 'green',
    icon: () => (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
  },
  "streak_100": {
    id: "streak_100",
    name: "Century Champion",
    description: "Maintained a 100-day streak",
    baseColor: 'yellow',
    icon: () => (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
      </svg>
    ),
  },
  "streak_365": {
    id: "streak_365",
    name: "Year Legend",
    description: "Maintained a 365-day streak",
    baseColor: 'orange',
    icon: () => (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
      </svg>
    ),
  },
};

// Color mapping for badge styles
const COLOR_STYLES = {
  'cyan': 'bg-cyan-600/10 border border-cyan-500/20',
  'pink': 'bg-pink-600/10 border border-pink-500/20',
  'lime': 'bg-lime-600/10 border border-lime-500/20',
  'teal': 'bg-teal-600/10 border border-teal-500/20',
  'indigo': 'bg-indigo-600/10 border border-indigo-500/20',
  'fuchsia': 'bg-fuchsia-600/10 border border-fuchsia-500/20',
  'red': 'bg-red-600/10 border border-red-500/20',
  'green': 'bg-green-600/10 border border-green-500/20',
  'yellow': 'bg-yellow-600/10 border border-yellow-500/20',
  'orange': 'bg-orange-600/10 border border-orange-500/20',
};

// Process badges using the actual API response structure
export const processBadgesWithProgress = (apiResponse) => {
  if (!apiResponse || !apiResponse.badges) {
    // Return all badges as locked if no data
    return Object.values(BADGE_DEFINITIONS).map(definition => ({
      id: definition.id,
      name: definition.name,
      description: definition.description,
      icon: definition.icon(),
      color: `bg-gray-800/20 border border-gray-700/50`,
      unlocked: false,
      progressPercentage: 0,
      progressText: "Not started",
      current: 0,
      required: 1,
      remaining: 1,
      isAchievable: false,
      status: "not_started"
    }));
  }

  // Process each badge using the actual API structure
  const processed = Object.entries(BADGE_DEFINITIONS).map(([id, definition]) => {
    const badgeData = apiResponse.badges[id];
    
    if (!badgeData) {
      // Badge not found in API response
      return {
        id,
        name: definition.name,
        description: definition.description,
        icon: definition.icon(),
        color: `bg-gray-800/20 border border-gray-700/50`,
        unlocked: false,
        progressPercentage: 0,
        progressText: "Not started",
        current: 0,
        required: 1,
        remaining: 1,
        isAchievable: false,
        status: "not_started"
      };
    }

    // Use the actual API response structure
    const isEarned = badgeData.is_earned || false;
    const progressPercentage = badgeData.progress_percentage || 0;
    const progressText = badgeData.progress_text || "Not started";
    const current = badgeData.current || 0;
    const required = badgeData.required || 1;
    const remaining = badgeData.remaining || 0;
    const isAchievable = badgeData.is_achievable || false;
    const status = badgeData.status || "not_started";

    // Determine badge color and style
    let color;
    if (isEarned) {
      color = "bg-green-600/20 border border-green-500/30 shadow-green-500/10";
    } else if (isAchievable) {
      color = "bg-blue-600/20 border border-blue-500/30 shadow-blue-500/10";
    } else if (progressPercentage > 0) {
      color = COLOR_STYLES[definition.baseColor] || "bg-blue-600/10 border border-blue-500/20";
    } else {
      color = "bg-gray-800/20 border border-gray-700/50";
    }

    return {
      id,
      name: definition.name,
      description: definition.description,
      icon: definition.icon(),
      color,
      unlocked: isEarned,
      progressPercentage,
      progressText,
      current,
      required,
      remaining,
      isAchievable,
      status
    };
  });

  return processed;
};

// Main function to get user badges with progress
export const getUserBadgesWithProgress = async (userData, userId, api, isOwnProfile) => {
  try {
    // Try to fetch from the backend API first
    if (api && userId) {
      try {
        const response = await api.get('/profile/me/badge-progress');
        
        if (response.data && response.data.badges) {
          return processBadgesWithProgress(response.data);
        }
      } catch (error) {
        console.error('Failed to fetch from badge progress API:', error);
      }
    }

    // Fallback: if we have userData with badges array
    if (userData?.badges) {
      const mockApiResponse = {
        badges: {},
        summary: {
          total_badges: Object.keys(BADGE_DEFINITIONS).length,
          earned_badges: Array.isArray(userData.badges) ? userData.badges.length : 0,
        }
      };
      
      // Convert userData.badges to API format
      if (Array.isArray(userData.badges)) {
        userData.badges.forEach(badgeId => {
          if (BADGE_DEFINITIONS[badgeId]) {
            mockApiResponse.badges[badgeId] = {
              name: BADGE_DEFINITIONS[badgeId].name,
              description: BADGE_DEFINITIONS[badgeId].description,
              current: 1,
              required: 1,
              remaining: 0,
              progress_percentage: 100,
              progress_text: "✅ Completed!",
              is_achievable: true,
              is_earned: true,
              earned_date: null,
              status: "completed"
            };
          }
        });
      }
      
      return processBadgesWithProgress(mockApiResponse);
    }

    // No data - return all as locked
    return processBadgesWithProgress({ badges: {} });
    
  } catch (error) {
    console.error('Error in getUserBadgesWithProgress:', error);
    return processBadgesWithProgress({ badges: {} });
  }
};

// Utility function to get next achievable badges
export const getNextAchievableBadges = (badges, limit = 3) => {
  return badges
    .filter(badge => !badge.unlocked && badge.progressPercentage > 0)
    .sort((a, b) => {
      if (a.isAchievable && !b.isAchievable) return -1;
      if (!a.isAchievable && b.isAchievable) return 1;
      return (b.progressPercentage || 0) - (a.progressPercentage || 0);
    })
    .slice(0, limit);
};

// Utility function to calculate badge statistics
export const getBadgeStats = (badges, apiResponse = null) => {
  const earned = badges.filter(badge => badge.unlocked).length;
  const total = badges.length;
  const inProgress = badges.filter(badge => !badge.unlocked && badge.progressPercentage > 0).length;
  const achievable = badges.filter(badge => badge.isAchievable && !badge.unlocked).length;

  return {
    earned,
    total,
    inProgress,
    achievable,
    completion: total > 0 ? Math.round((earned / total) * 100) : 0,
    summary: apiResponse?.summary || null
  };
};

export default {
  BADGE_DEFINITIONS,
  getUserBadgesWithProgress,
  processBadgesWithProgress,
  getNextAchievableBadges,
  getBadgeStats
};